import React from 'react';
import Axios from 'axios';

import GetCollection from '@src/api/GetCollection';
import { generateCollection } from '@src/factories';
import useAuthenticationTokens from '@src/hooks/useAuthenticationTokens';
import { Collection } from '@src/types';

const useCollection = (id: string) => {
  const {
    tokens: { accessToken },
  } = useAuthenticationTokens();
  const [collection, setCollection] = React.useState<Collection>();
  React.useEffect(() => {
    const cancelTokenSource = Axios.CancelToken.source();

    GetCollection(accessToken, id, { cancelToken: cancelTokenSource.token })
      .then(({ data }) => {
        console.log(data.collection);
        setCollection(generateCollection(data.collection));
      })
      .catch(console.log);
    return () => cancelTokenSource.cancel('Get collection canceled');
  }, [accessToken, id]);

  return collection;
};

export default useCollection;
